<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header/>
    <b-container fluid>
      <b-row>
        <b-col>
            <b-card header-tag="header">
              <template #header>
                <div class="titulos">
                  <div class="seccionTitle">
                    <em class="fa fa-cog mLeft"></em>
                    <div class="headerTxt mLeft">
                      <b-icon class="icono" icon="file-text"></b-icon>Administración de Empresas
                    </div>
                  </div>
                  <div class="seccionCodigo">
                    <div>Admin_empresas</div>
                  </div>
                </div>
              </template>
              <b-card-body>
                <b-row v-if="!blnFormulario">
                  <b-col>
                      <b-row>
                        <b-col align="left">
                          <b-form-group align="left" id="buscar">
                            <label for="input-buscar">Busqueda de Empresas</label>
                            <b-input-group size="sm" class="mb-2">
                              <b-input-group-prepend is-text>
                                <b-icon icon="search"></b-icon>
                              </b-input-group-prepend>
                              <b-form-input v-if="$localStorageService.can('BO_11_buscar_emp')" id="input-buscar" placeholder="Nombre de la Empresa" v-model="filtro" v-on:keyup="btnBuscar()"></b-form-input>
                            </b-input-group>
                          </b-form-group>
                        </b-col>
                        <b-col align="right" v-if="$localStorageService.can('BO_11_agregar_emp')">
                          <b-button variant="outline-success" v-on:click="agregar()">Agregar</b-button>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col v-if="!loaderObtenerEmpresa">
                          <b-table thead-tr-class="columnas" class="parrafos" id="empresas" hover responsive="true" :items="lstEmpresas" :fields="fields"  :per-page="registrosPorPagina"  :current-page="paginaActual">
                              <template v-slot:cell(Acciones)="row">  
                                <b-button-group>
                                  <b-button
                                    v-if="$localStorageService.can('BO_11_edit_emp')" 
                                    title="Modificar Empresa"
                                    size="sm" 
                                     variant="outline-warning"
                                    @click="editar(row.item)"
                                  ><em class="fa fa-pencil"></em></b-button>

                                   <b-button  
                                    v-if="$localStorageService.can('BO_11_desact_emp')  &&
                                    row.item.estatus != false &&
                                    row.item.estatus != null" 
                                    title="Inactivar Empresa"
                                    variant="outline-danger"
                                    size="sm" 
                                    @click="activarDesactivar(row.item, false)" 
                                  > <b-icon icon="arrow-down"></b-icon></b-button>


                                   <b-button  
                                    v-if="$localStorageService.can('BO_11_act_emp')  &&
                                    row.item.estatus != true" 
                                    title="Activar Empresa"
                                    variant="outline-success"
                                    size="sm" 
                                    @click="activarDesactivar(row.item, true)"  
                                  > <b-icon icon="arrow-up"></b-icon></b-button>


                                  
                                </b-button-group> 
                              </template> 
                              <template v-slot:cell(estatus)="row">
                                <b-alert
                                  variant="success"
                                  size="sm"
                                  show
                                  v-if="row.item.estatus"
                                  >ACTIVO</b-alert
                                >
                                <b-alert variant="secondary" size="sm" show v-else
                                  >INACTIVO</b-alert
                                >
                              </template>
                              <template v-slot:cell(cuentas)="row">
                                <b-button
                                  @click="
                                    showModal(
                                      row.item.idEmpresa,
                                      row.item.nombreComercial
                                    )
                                  "
                                  variant="outline-info"
                                  >Ver Cuentas</b-button
                                >
                              </template>

                              <template v-slot:cell(fechaModificacion)="row">
                                {{ row.item.fechaModificacion | formatoFecha }}
                              </template>

                            <template v-slot:cell(tieneLogo)="row">
                              <b-icon v-if="row.item.tieneLogo === false" font-scale="1.5" icon="x-circle-fill" variant="danger"></b-icon>
                              <b-icon v-if="row.item.tieneLogo === true" font-scale="1.5" icon="check-circle-fill" variant="success"></b-icon>
                            </template>
                              
                          </b-table>
                          <b-pagination
                              v-if="lstEmpresas !== undefined && lstEmpresas.length > 15"
                              align="center"
                              v-model="paginaActual"
                              :total-rows="lstEmpresas.length"
                              :per-page="registrosPorPagina"
                              aria-controls="empresas"
                          ></b-pagination>
                        </b-col>
                        <b-col align="center" v-if="loaderObtenerEmpresa">
                          <b-spinner variant="primary" label="Spinning"></b-spinner>
                        </b-col>
                      </b-row>
                      <!-- <b-row>
                         <b-col>
                           <b-pagination
                               v-model="currentPage"
                               :total-rows="rows"
                               :per-page="perPage"
                               aria-controls="tabla_empresas"
                           ></b-pagination>
                         </b-col>
                       </b-row>-->
                  </b-col>
                </b-row>
                <b-row v-if="blnFormulario">
                  <b-col>
                    <form-empresas :empresaActual="empresaTO" v-on:speak="speakMethod($event)" v-on:guardar="guardar($event)"></form-empresas>
                  </b-col>
                </b-row>


                   <b-modal
                ref="cuentas"
                :title="
                  'Cuentas de la empresa: ' +
                  empresaEnModal +
                  ' (Total cuentas:' +
                  cuentalistaPorEmpresa.length +
                  ')'
                "
                hide-footer
                size="xl"
              >
                <br />
                <b-table
                  hover
                  responsive
                  thead-tr-class="columnas"
                  class="parrafos"
                  id="tabla_cuentalistaPorEmpresa"
                  :items="cuentalistaPorEmpresa"
                  :fields="fieldscuentas"
                >
                  <template v-slot:cell(cuentaActiva)="row">
                    <b-alert
                      variant="success"
                      show
                      v-if="row.item.cuentaActiva"
                      >ACTIVO</b-alert
                    >
                    <b-alert variant="secondary" show v-else>INACTIVO</b-alert>
                  </template>
                  <template v-slot:cell(fechaModificacion)="row">
                    {{ row.item.fechaModificacion | formatoFecha }}
                  </template>
                </b-table>
                <br />
                <b-button
                  class="mt-3"
                  variant="outline-info"
                  block
                  @click="hideModal()"
                  >Cerrar</b-button
                >
                <br /><br />
              </b-modal>
              <br /><br /><br /><br />
              </b-card-body>
            </b-card>
        </b-col>
      </b-row>
    </b-container>


    <b-modal ref="modal_activar_desactivar" title="Desactivar">
      <b-container fluid>
        <b-row>
          <b-col>
            ¿Desea {{activar_desactivar_texto}} la Empresa?
          </b-col>
        </b-row>
      </b-container>
      <div slot="modal-footer">
        <b-button variant="outline-primary" v-on:click="onConfirm()">Aceptar</b-button>
        <b-button variant="outline-danger" v-on:click="onCancel()">Cancelar</b-button>
      </div>
    </b-modal>


  </div>
</template>

<script>
import formEmpresas from "./form-empresas";
import Header from "@/components/Header";
export default {
  name: "admin-empresas",
  components:{
    formEmpresas,
    Header
  },
  data: ()=> ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    fields: [
      {key: "idEmpresa", label: "Id", sortable: true},
      {key: "nombreComercial", label: "Nombre", sortable: true},
      {key: "rfc", label: "RFC", sortable: true},
      {key: "tipoNombre", label: "Tipo", sortable: true},
      {key: "estatus", label: "Estatus", sortable: true},
      { key: "tieneLogo", label: "Logo", sortable: true },
      {
        key: "nombreUsuarioModifica",
        label: "Usuario Modificación",
        sortable: true,
      },
      { key: "fechaModificacion", label: "Fecha Modificación", sortable: true },
      { key: "cuentas", label: "Ver Cuentas de la empresa", sortable: true },
      "Acciones",
    ],
    loaderObtenerEmpresa:false,
    blnFormulario: false,
    filtro:'',
    lstEmpresas:[],
    empresaTO:null,
    lstEmpresasBK:[],
    btnModal: false,
    idEmpresa:null,
    perPage: 3,
    currentPage: 1,
    registrosPorPagina: 15,
    paginaActual: 1,
    activar_desactivar : null,
    activar_desactivar_texto: null,
    empresaEnModal: null,
    cuentalistaPorEmpresa: [],    
    fieldscuentas: [
      { key: "idCuenta", label: "Id", sortable: true },
      { key: "nombreCuenta", label: "Nombre", sortable: true },
      { key: "cuentaActiva", label: "Estatus", sortable: true },
      {
        key: "nombreUsuarioModifica",
        label: "Usuario modificación",
        sortable: true,
      },
      {
        key: "fechaModificacion",
        label: "Fecha Modificación",
        sortable: true,
      },
    ],
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.lstEmpresasBK = this.lstEmpresas;
    this.obtenerEmpresas();
  },
  methods:{
    /**
     * Funcion para buscar
     */
    btnBuscar(){
      this.lstEmpresas = this.lstEmpresasBK;
      this.lstEmpresas = this.lstEmpresas.filter(element => {
        return element.nombreComercial.toLowerCase().indexOf(this.filtro.toString().toLowerCase()) > -1
            || element.razonSocial.toLowerCase().indexOf(this.filtro.toString().toLowerCase()) > -1;
      });
    },
    limpiarFiltro(){
      this.filtro = '';
      this.btnBuscar();
    },
    /**
     * Funcion para abrir formulario
     */
    agregar(){
      this.empresaTO = null;
      this.blnFormulario = true;
    },
    /**
     * Funcion para editar registro
     */
    editar(empresa){
      this.empresaTO = empresa;
      this.blnFormulario = true;
    },
    activarDesactivar( empresa, act_dec){
      this.btnModal = true;
      this.abrirModal(); 
      this.idEmpresa = empresa.idEmpresa;
      if(act_dec){
        this.activar_desactivar_texto = 'ACTIVAR';
        this.activar_desactivar = act_dec;
      } else {
        this.activar_desactivar_texto = 'INACTIVAR';
        this.activar_desactivar = act_dec;
      }
    },
    /**
     * Funcion para cerrar formulario
     */
    cancelar(){
      this.blnFormulario = false;
    },
    /**
     * Funcion que se activa al escuchar al hijo
     * @param msg
     */
    speakMethod: function () {
      this.cancelar();
    },
    /**
     *funcion para guardar registro datos dummin para prebas de front
     **/
    guardar: function (){
      this.cancelar();
      this.obtenerEmpresas();
    },
    /**
     *funcion para cancelar eliminado
     */
    onCancel(){
      this.btnModal = false;
      this.cerrarModal();
    },
    /**
     * funcion para confirmar eliminado de registro
     */
    onConfirm(){
      const _this = this;
      this.btnModal = false;
      this.cerrarModal();
      this.lstEmpresas.splice(this.index, 1);
      const params = {
        idEmpresa: this.idEmpresa,
        estatus: this.activar_desactivar
      }
      this.$http.post(this.$api + "empresas/cambiarestatus", params)
      .then(response => {
       _this.$swal.fire({
            icon: "success",
            title: "Aviso",
            text: response.data.message,
        });
        this.activar_desactivar = true;
        this.activar_desactivar_texto = null;

      }).catch(function (error) {
        var message = error.response.data.message
            ? error.response.data.message
            : "Error al actualizar la empresa";
          _this.$swal.fire({
            icon: "error",
            title: "Aviso",
            text: message,
          });

      }).finally(() =>   
         this.obtenerEmpresas()
      );
    },
    /**
     * Funcion para obtener los datos del back
     *
     */
    obtenerEmpresas(){
      this.lstEmpresas = [];
      this.loaderObtenerEmpresa = true;
      this.$http.get(this.$api + "empresas/obtener/admin").then(response => {
        if (response.data.data){
          let resultado = response.data.data;
          resultado.forEach(it => {
            this.paginaActual=1;
            this.lstEmpresas.push(it);
          });
          this.lstEmpresasBK = this.lstEmpresas;
          this.loaderObtenerEmpresa = false;
        }
      }).catch(function (error) {
        this.loaderObtenerEmpresa = false;
        console.error(error);
      });
    },
    /**
     * Funcion para abrir la modal por referencia
     */
     abrirModal(){
       this.$refs['modal_activar_desactivar'].show();
     },
    /**
     * Funcion para cerrar la modal por referencia
     */
    cerrarModal(){
      this.$refs['modal_activar_desactivar'].hide();
    },
    showModal(idEmpresa, nombre) {
      this.empresaEnModal = nombre;
      this.obtenerCuentasPorIdCempresa(idEmpresa);
      this.$refs["cuentas"].show();
    },
    hideModal() {
      this.$refs["cuentas"].hide();
    },
    obtenerCuentasPorIdCempresa(idEmpresa) {
      this.cuentalistaPorEmpresa = [];
      this.loading = true;
      const parametros = {idEmpresa: idEmpresa}
      this.$http
        .post(
          this.$api +
            "empresas/obtener/cuentas/porempresa/sinestatus", parametros
        )
        .then((response) => {
          if (response.data.data) {
            this.cuentalistaPorEmpresa = response.data.data;
          }
        })
        .catch(function (error) {
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  computed:{
    rows(){
      return this.lstEmpresas.length;
    }
  },
  notifications:{

  }
}
</script>

<style scoped>

</style>
